//超麦云助手
export const chaoMaiHelperRouter = [
  {
    path: '/service/chaoMaiCloud/pro',
    name: 'ChaoMaiProductSync',
    component: () => import('@/views/service/serviceProvider/chaoMaiCloud/ChaoMaiProductSync'),
    meta: {
      title: '商品绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/chaoMaiCloud/order',
    name: 'ChaoMaiOrderList',
    component: () => import('@/views/service/serviceProvider/chaoMaiCloud/ChaoMaiOrderList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/chaoMaiCloud/account',
    name: 'ChaoMaiStores',
    component: () => import('@/views/service/serviceProvider/chaoMaiCloud/ChaoMaiStores'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  }
]